export default __webpack_public_path__ + "static/media/Olim4.a5df98bd.png";